import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { RedBookResponse } from '../../../types/redbook';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const getRedBookFamilies = (
  constructGet: ConstructGet,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<RedBookResponse> | undefined> =>
  constructGet<NonPaginatedResponse<RedBookResponse>>(
    `${PLUGIN_BASE_PATH}/red-book-request/list-car-families`,
    { params },
  );
